<div class="media-library" (dragover)="onDragOver($event)" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <div class="upload-options">
    <div class="upload-area" [class.drag-over]="filesDraggedOver" (click)="clickOnInput()">
      <input type="file" id="file-input" multiple [accept]="supportsVideos ? 'image/*, video/mp4, video/webm' : 'image/*'" style="display: none" />
      <div class="upload-content">
        <div class="primary-text hint-text">
          @if (supportsVideos) {
            <mat-icon class="material-icons" [style.color]="filesDraggedOver ? 'var(--linkColor)' : ''">cloud_upload</mat-icon>
            <span>
              {{ "campaign.widget.sidebar.media.upload-images.drag-drop-hint-videos" | translate }}
            </span>
            <span>
              {{ "campaign.widget.sidebar.media.upload-images.drag-drop-hint-fileformats" | translate }}
            </span>
          } @else {
            <mat-icon class="material-icons" [style.color]="filesDraggedOver ? 'var(--linkColor)' : ''">cloud_upload</mat-icon>
            <span>
              {{ "campaign.widget.sidebar.media.upload-images.drag-drop-hint" | translate }}
            </span>
          }
        </div>
      </div>
    </div>
    <input
      [style.display]="'none'"
      type="file"
      name="file"
      multiple
      [accept]="supportsVideos ? 'image/*, video/mp4, video/webm' : 'image/*'"
      id="media"
      (change)="handleInputChange($event)" />
    @if (selectingMedia) {
      <div class="search paste-link">
        <h2>{{ "generic.or" | translate }}</h2>
        <mat-form-field class="input-full-width" appearance="outline">
          @if (supportsVideos) {
            <mat-label>{{ "campaign.widget.sidebar.media.upload-images.paste-img-or-video-url" | translate }}</mat-label>
          } @else {
            <mat-label>{{ "campaign.widget.sidebar.media.upload-images.paste-img-url" | translate }}</mat-label>
          }
          <input type="text" matInput [(ngModel)]="mediaUrl" (keydown.enter)="saveMediaUrl()" />
          @if (!mediaUrlInvalidMessage) {
            <i class="material-icons">link</i>
          }
          @if (mediaUrlInvalidMessage) {
            <i [matTooltip]="mediaUrlInvalidMessage | translate" class="material-icons" style="cursor: pointer; color: var(--error)">error</i>
          }
        </mat-form-field>
        <button mat-stroked-button class="gray-button upload-url" (click)="saveMediaUrl()">{{ "generic.add" | translate }}</button>
      </div>
    }
  </div>
  <div class="search">
    <mat-form-field class="input-full-width" appearance="outline">
      <input #searchInput type="text" matInput placeholder="{{ 'generic.search' | translate }}" [(ngModel)]="searchString" (input)="searchMedia($event)" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <mat-accordion>
    <app-media-picker
      [default]="defaultCategory"
      [searchString]="searchString"
      [selectingMediaFile]="selectingMedia"
      (addCollection)="addCollection($event)"
      (onSelect)="selectMediaFile($event)"
      (collectionSelected)="collectionSelected($event)"
      [category]="MediaCategory.Photos" />
    <app-media-picker
      [default]="defaultCategory"
      [searchString]="searchString"
      [selectingMediaFile]="selectingMedia"
      (addCollection)="addCollection($event)"
      (onSelect)="selectMediaFile($event)"
      (collectionSelected)="collectionSelected($event)"
      [category]="MediaCategory.Graphics" />
    @if (supportsVideos) {
      <app-media-picker
        [default]="defaultCategory"
        [searchString]="searchString"
        [selectingMediaFile]="selectingMedia"
        [supportsVideos]="supportsVideos"
        (addCollection)="addCollection($event)"
        (onSelect)="selectMediaFile($event)"
        (collectionSelected)="collectionSelected($event)"
        [category]="MediaCategory.Videos" />
    }

    @if (!hideIcons) {
      @if (supportsFontIcons) {
        <mat-expansion-panel #iconPanel (opened)="iconPanelOpen = true" (closed)="iconPanelOpen = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ "campaign.widget.sidebar.media.icons" | translate }}
            </mat-panel-title>
            @if (searchString?.length) {
              <div class="results">{{ filteredIcons.length }} {{ "generic.results" | translate }}</div>
            }
            @if (selectingMedia) {
              <div class="actions">
                <i
                  class="material-icons"
                  (click)="$event.stopPropagation(); iconColor = null; iconColorDisplay = 'var(--textColor)'"
                  [matTooltip]="'Default color'">
                  format_color_reset
                </i>
                <div
                  matSuffix
                  class="color-picker-button"
                  (click)="$event.stopPropagation()"
                  [matTooltip]="'Choose color'"
                  [matMenuTriggerFor]="mixColorMenu"
                  [style.background-color]="iconColorDisplay"></div>
                <mat-menu #mixColorMenu="matMenu" class="colors-menu-modal">
                  <div mat-menu-item class="wrapper-color-picker" [disableRipple]="true">
                    <app-color-picker
                      (click)="$event.stopPropagation()"
                      (customColorUpdated)="changeOnColorPicker($event)"
                      [inputAccountColors]="accountColorVariables"
                      [currentColor]="iconColor"
                      [sourceItem]="'account-color-edit-dialog'"
                      [firstTab]="0"></app-color-picker>
                  </div>
                </mat-menu>
              </div>
            }
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="icons-container">
              @if (!!materialIcons && materialIcons.length > 0) {
                <div class="list">
                  @for (icon of filteredIcons; track icon) {
                    <div class="item" (click)="selectIcon(icon)" [ngClass]="{ 'dark-background': iconColorIsBright }">
                      <i
                        class="material-symbols-outlined symbol"
                        [style.color]="iconColorDisplay"
                        style="
                          font-variation-settings:
                            &quot;OPSZ&quot; 24,
                            &quot;wght&quot; 400,
                            &quot;FILL&quot; 1,
                            &quot;GRAD&quot; 1;
                        ">
                        {{ icon.name }}
                      </i>
                      <div class="name" [style.color]="iconColorDisplay">
                        {{ icon.display }}
                      </div>
                    </div>
                  }
                </div>
              }
              @if (materialIcons !== null && materialIcons.length === 0) {
                <div class="no-icons">{{ "campaign.widget.component.image.no-icons" | translate }}</div>
              }
              @if (materialIcons === null) {
                <div class="loading-container">
                  <mat-spinner [diameter]="64" [strokeWidth]="2"></mat-spinner>
                </div>
              }
            </div>
          </ng-template>
        </mat-expansion-panel>
      }
    }
  </mat-accordion>
</div>
